export const categories = [
  {
    id: 'yule',
    slug: 'yule',
    name: '娱乐圈',
    description: '明星八卦、影视内幕、综艺黑幕，娱乐圈不为人知的真实故事',
    icon: 'ri-star-line',
    articleCount: 128,
  },
  {
    id: 'shangye',
    slug: 'shangye',
    name: '商业内幕',
    description: '企业黑幕、资本博弈、商业欺诈，揭露商业世界的真实面目',
    icon: 'ri-briefcase-line',
    articleCount: 96,
  },
  {
    id: 'shehui',
    slug: 'shehui',
    name: '社会揭秘',
    description: '社会热点、民生黑幕、权力腐败，直击社会最深层的问题',
    icon: 'ri-earth-line',
    articleCount: 85,
  },
  {
    id: 'zhengjie',
    slug: 'zhengjie',
    name: '政界风云',
    description: '官场内幕、权力斗争、政策博弈，揭开政治幕后的真相',
    icon: 'ri-government-line',
    articleCount: 73,
  },
  {
    id: 'keji',
    slug: 'keji',
    name: '科技黑幕',
    description: '数据泄露、算法操控、科技垄断，科技巨头不愿公开的秘密',
    icon: 'ri-cpu-line',
    articleCount: 61,
  },
  {
    id: 'qita',
    slug: 'qita',
    name: '其他爆料',
    description: '体育、教育、医疗等各领域的深度内幕与独家揭秘',
    icon: 'ri-flashlight-line',
    articleCount: 42,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});